class ProducerCreationDto {
    producerCode
    nameChinese
    nameEnglish
    addressChinese
    addressEnglish
    unifiedSocialCreditCode
    contact
    contactModel

    static getRules() {
        const lengthValidate = (value) => {
            if (value) {
                if (value.length === 18) {
                    return new Promise(resolve => resolve(true))
                } else {
                    return new Promise(resolve => resolve(false))
                }
            } else {
                return new Promise(resolve => resolve(true))
            }
        }
        return {
            producerCodeRule: [
                {
                    required: true, message: '请输入3-8位数字、字母组合生产商编码', trigger: 'onBlur',
                    pattern: /^[a-zA-Z0-9]{3,8}$/
                }
            ],
            nameChineseRule: [
                {required: true, message: '请输入中文名称', trigger: 'onBlur'}
            ],
            nameEnglishRule: [
                {required: true, message: '请使用英文标点及字母', trigger: 'onBlur',pattern: /^[a-z_A-Z0-9-.!@#$%\\^&*)(+={}[\]/",'<>~·`?:;|\s]+$/}
            ],
            addressChineseRule: [
                {required: true, message: '请输入中文地址', trigger: 'onBlur'}
            ],
            addressEnglishRule: [
                {required: true, message: '请使用英文标点及字母', trigger: 'onBlur',pattern: /^[a-z_A-Z0-9-.!@#$%\\^&*)(+={}[\]/",'<>~·`?:;|\s]+$/}
            ],
            unifiedSocialCreditCodeRule: [
                {
                    message: '请输入由字母、数字组合长度18位代码', trigger: 'onBlur',
                    pattern: /^[a-zA-Z0-9]+$/, validator: lengthValidate
                }
            ],
        }
    }

}

export default ProducerCreationDto